import { render, staticRenderFns } from "./launchAd.vue?vue&type=template&id=3967cdb0&scoped=true&"
import script from "./launchAd.vue?vue&type=script&lang=js&"
export * from "./launchAd.vue?vue&type=script&lang=js&"
import style0 from "./launchAd.vue?vue&type=style&index=0&id=3967cdb0&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3967cdb0",
  null
  
)

export default component.exports